import { FieldValidator } from "../modules/form/store";

export const required = ({ name, value }, { values }): boolean => {
    return value !== '' && value !== undefined && value !== null;
};

export const requiredNonZero = ({ name, value }, { values }): boolean => {
    return value !== '' && value !== undefined && value !== null && value !== 0;
};

export const validateOperatingTimeOrCount = (oldValue, newValue): { type, difference } | null => {
    if ((newValue < oldValue || newValue - 40 >= oldValue) && oldValue > 0) {
        if (newValue < oldValue) {
            return { type: 'underLimit', difference: oldValue - newValue };
        } else {
            return { type: 'overLimit', difference: newValue - oldValue };
        }
    }
    return null;
};

export const checkTimeNumberFormat = (event, currentValue) => {
    const charCode = event.charCode;

    const isDigit = charCode >= 48 && charCode <= 57;
    const isComma = charCode === 44;

    if (isDigit || isComma) {
        if (isComma && currentValue.includes(",")) {
            event.preventDefault(); // prevent double comma
        }
    } else {
        event.preventDefault(); // prevent non-digit, non-comma input
    }
};

export const minValidator = (min: number): FieldValidator => (field) => {
    if (field.value === undefined || field.value === null || field.value === '') return true;
    if (typeof field.value !== 'number') return false;
    return field.value >= min;
};

export const maxValidator = (max: number): FieldValidator => (field) => {
    if (field.value === undefined || field.value === null || field.value === '') return true;
    if (typeof field.value !== 'number') return false;
    return field.value < max;
}

export const requiredArray = ({ name, value }, { values }): boolean => {
    return value !== undefined && value !== null && value.length;
};

export const requiredBoolean = ({ name, value }, { values }): boolean => {
    return value !== undefined && value !== null && value !== false;
};